// src/components/Layout.js
import { SchoolFooter } from "components/SchoolFooter/schoolFooter";
import { SchoolHeader } from "components/ShoolHeader/schoolHeader";
import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <div>
      <div className="flex flex-col min-h-screen">
       <SchoolHeader />
        {/* Main Content */}
        <div className="flex-grow pt-24">
        <Outlet />
        </div>

        {/* Footer */}
        <SchoolFooter />
      </div>

    </div>
  );
};

export default Layout;
